import { Helmet } from 'react-helmet'
import { SapLogFilterForm, SapLogTable } from 'components/logsSap'
import { Button } from 'components/common'
import ActiveFilterChip from 'components/common/activeFilterChip'
import { ExportIcon, FilterIcon } from 'components/icons'
import { useState } from 'react'
import toast from 'react-hot-toast'
import { downloadSapLogs } from 'utils/api/logsApi'
import { useQuery } from 'hooks'
import { filterEmptyValues } from 'utils/helpers'
import { FILTER_FIELD_SAP_LOG } from 'components/logsSap/sapLogFilterForm'

const SapLogs = () => {
  const [showFilter, setShowFilter] = useState(false)

  const { getQuery } = useQuery()

  const toggleFilterForm = () => {
    setShowFilter(!showFilter)
  }

  const handleExport = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      const logFilter = filterEmptyValues(getQuery(FILTER_FIELD_SAP_LOG))

      await downloadSapLogs(
        Object.keys(logFilter).length > 0 ? logFilter : undefined,
      )
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | SAP Logs </title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">SAP Logs</div>

        <div className="flex flex-wrap items-center justify-end gap-1">
          <Button
            buttonText="Filters"
            className={`rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary ${
              showFilter && 'bg-gray-200'
            } hover:bg-gray-200`}
            variant="custom"
            icon={<FilterIcon />}
            iconClassName="text-dataTableIcon"
            onClick={toggleFilterForm}
          />
          <Button
            type="button"
            buttonText="Export"
            variant="custom"
            iconClassName="!h-5 !w-5 text-dataTableIcon"
            icon={<ExportIcon />}
            className="rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200"
            onClick={handleExport}
          />
        </div>
      </div>

      {!showFilter && <ActiveFilterChip filterKey={FILTER_FIELD_SAP_LOG} />}

      {showFilter ? (
        <SapLogFilterForm toggleFilterForm={toggleFilterForm} />
      ) : (
        <SapLogTable />
      )}
    </>
  )
}

export default SapLogs
